export default "__VITE_ASSET__cbK9egOF__"